// Shared design tokens for the landing page.
// Keep every color/spacing decision here so a change lands in one place.

export const c = {
  bg: "#F8F9FC",
  bgSoft: "rgba(255,255,255,0.74)",
  bgTint: "#EEF0FF",
  ink: "#171A2B",
  inkSoft: "#596176",
  inkMuted: "#9299AC",
  purple: "#8B7CFF",
  purpleDeep: "#6258E8",
  purpleInk: "#4E46C7",
  teal: "#DCEBFA",
  white: "#FFFFFF",
  line: "rgba(31,36,63,0.10)",
  lineStrong: "rgba(31,36,63,0.16)",
};

export const mono = "'IBM Plex Mono', ui-monospace, monospace";

export const section = {
  px: { xs: 2.5, md: 3 },
  pb: { xs: 7, md: 12 },
};

export const maxW = "1140px";

// Small caps mono label used above every section heading.
export const eyebrowSx = {
  fontFamily: mono,
  fontSize: "11.5px",
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: c.purpleDeep,
  mb: 2.25,
};

// Big display heading.
export const h2Sx = {
  fontSize: "clamp(30px, 4.6vw, 58px)",
  lineHeight: 1.04,
  letterSpacing: "-0.035em",
  fontWeight: 600,
  color: c.ink,
  textWrap: "balance",
};

export const cardSx = {
  bgcolor: c.bgSoft,
  border: `1px solid ${c.line}`,
  borderRadius: "28px",
  p: { xs: 3.5, md: 4.25 },
  boxShadow: "0 18px 50px -38px rgba(55, 56, 113, 0.55)",
  transition: "transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease",
  "&:hover": {
    transform: "translateY(-5px)",
    borderColor: "rgba(98,88,232,0.28)",
    boxShadow: "0 24px 58px -38px rgba(55, 56, 113, 0.7)",
  },
};

export const pillButtonSx = {
  borderRadius: "980px",
  textTransform: "none",
  fontSize: "15px",
  fontWeight: 500,
  px: 3.5,
  py: 1.75,
};
